import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle size={48} className="text-rose-400" />
      <h1 className="mt-4 font-heading text-2xl font-bold text-white">Payment cancelled</h1>
      <p className="mt-2 text-slate-400">No charge was made. Your items are still waiting.</p>
      <Link to="/cart" className="btn-gold mt-6" data-testid="back-to-cart-btn">Back to cart</Link>
    </div>
  );
}
